import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Driver from "../../../assets/images/v3/driver.png";
import DriveBetter from "../../../assets/images/v3/drive_better.svg";
import flag from "../../../assets/images/v3/icons/color_bar.svg";

const Complete = (props) => {
	let history = useHistory();
	const renewalData = useSelector((state) => state.RenewalData);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="complete general d-flex justify-content-center">
			<div className="otcontainer1 nopadding">
				<div className="col-12 px-1 px-md-4">
					<div className="row justify-content-md-center">
						<h1 className="otmb-4 otmt-4" style={{ color: "#00778a" }}>
							Order Complete!
						</h1>
					</div>
				</div>
				<div className="col-12 px-1 px-md-4 mb-5">
					<h5 className="text-capitalize" style={{ color: "#979797" }}>
						Order #{renewalData.order_number}
					</h5>
					<div className="heading">
						<div className="desc"></div>
					</div>
					<p className="mt-4">
						We’re thrilled to have you back as a member of OpenTrack Drive! Your
						policy documents and a receipt have been emailed to you.
					</p>
					<p className="mt-4 otmb-3">
						You can access your policy documents, receipts of payment, and make
						changes to your account at 
						<a href={`${window.location.origin}/v3/dashboard/dashboard_home`}>
							<span className="t3">My Dashboard</span>
						</a>
						.
					</p>
					<h5 className="mt-4 text-capitalize" style={{ color: "#979797" }}>
						About Your Policy
					</h5>
					<div class="heading">
						<div class="desc"></div>
					</div>
					<div className="mt-5">
						<p className="t6 mb-2">WHEN DOES MY POLICY START?</p>
						<p className="otmb-3">
							OpenTrack policies are effective at 12:01am (EST) the day of your
							enrollment or the day you select as your effective date.
						</p>
						<p className="t6 mb-2">HOW WILL I RECEIVE MY POLICY DOCUMENTS?</p>
						<p className="otmb-3">
							All of your policy documents will be emailed to you in the coming
							days and are also conveniently located online within your
							OpenTrack Account Dashboard. Please contact us if you have any
							questions or need assistance (612)231-1522.
						</p>
						<p className="t6 mb-2">
							Do you have any recommendations for driver coaches?
						</p>
						<p className="otmb-3">
							We highly recommend spending 1-on-1 time with an experienced
							driver coach. Regardless of your current skill and experience
							level, working with a talented driver coach is the fastest way to
							improved lap times. If you're interested, you can find more
							information and our current recommended coaches here.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Complete;
